import { render, staticRenderFns } from "./SponsoredRecommendationBackdrop.vue?vue&type=template&id=4c0deed2&scoped=true"
import script from "./SponsoredRecommendationBackdrop.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationBackdrop.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationBackdrop.vue?vue&type=style&index=0&id=4c0deed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0deed2",
  null
  
)

export default component.exports